module.exports = __webpack_public_path__ + "img/PredictiveMaintenance_einfarbig_RGB.a3796493.svg";